/**
 *
 * @author arman
 * @since 7/14/17
 *
 */
import React from 'react';
import utils from '../../utility/utils';
import gStyle from '../../utility/styles';
import FlatButton from 'material-ui/FlatButton';
import BoxHeader from '../shared/box-header.component';
import appConstants from '../../utility/app-constants';

const styles = {
  root: {

  },
  leftSection: {
    display: 'inline-block'
  },
  rightSection: {
    display: 'inline-block',
    float: 'right'
  },
  innerDiv: {
    margin: '8px',
    height: '25px',
  },
  operator: {
    fontWeight: 'bold',
    background: 'url(./images/icons/mission/view/operator.png) no-repeat',
  },
  text: {
    margin: '8px',
    height: '25px',
    color: '#000000',
    fontSize: '15px',
    marginLeft: '10px',
  },
  time: {
    height: '25px',
    color: '#000000',
    fontSize: '15px',
    marginTop: '5px',
    marginLeft: '10px',
  },
  operatorText: {
    color: '#000000',
    fontSize: '15px',
    marginTop: '5px',
    marginLeft: '40px',
    display: 'inline-block'
  },
  number: {
    color: "#000000",
    fontSize: "15px",
    marginTop: '-10px',
    marginLeft: "10px",
  },
  status: (status) => {
    return {
      float: 'right',
      minWidth: '100px',
      display: 'inline-block',
      font: 'Helvetica',
      fontSize: '18px',
      textAlign: 'center',
      backgroundColor: gStyle.statusColor[status],
      padding: '12px',
      borderRadius: '8px',
      color: '#FFFFFF',
      margin: '10px',
      fontWeight: 'bold'
    };
  },
  payment: (status) => {
    return {
      float: 'right',
      minWidth: '100px',
      display: 'inline-block',
      font: 'Helvetica',
      fontSize: '18px',
      textAlign: 'center',
      backgroundColor: gStyle.paymentStatusColor[status],
      padding: '12px',
      borderRadius: '8px',
      color: '#FFFFFF',
      margin: '10px',
      fontWeight: 'bold'
    };
  },
  anchor: {
    marginLeft: '10px'
  }
};

/**
 *
 * @param {object} mission
 * @param {function} changeAssignee
 * @param {function} onNumberClick
 * @param {string} className
 * @param {object} style
 * @constructor
 */
const MissionBasicInfo = ({mission, changeAssignee, onNumberClick, className, style}) => (
  <div className={className} style={{...styles.root, ...style}}>
    <BoxHeader title='Mission Basic Info'/>
    <div style={styles.leftSection}>
    <div style={{...styles.operator, ...styles.innerDiv}}>
        <div style={styles.operatorText}>{mission.assignee.name}</div>
      </div>
    <div style={styles.text}>
        <span>Mission Number: </span>
        <span>{mission.mission_number}</span>
      </div>
    <div style={styles.text}>
        <span> Caller: </span>
        <span>{mission.patient.user.name}</span>
      </div>
      <div style={styles.number}>
        <span> Phone: </span>
          <FlatButton
            label={mission.patient.user.phone}/>
      </div>
      <div style={styles.time}>
        <span>Date/time: </span>
        <span>{utils.toAppDate(mission.created_at)}</span>
      </div>
      {
        ( mission.status === appConstants.DOCTOR_CANCELED || mission.status === appConstants.OPERATOR_CANCELED || mission.status === appConstants.PATIENT_CANCELED ) && mission.cancel_reason &&
        <div style={{...styles.text, ...styles.innerDiv}}>
          <span>Cancel Reason: </span>
          <span>{mission.cancel_reason}</span>
        </div>
      }
      {
        mission.payment_status &&  
        <div>
          <div style={styles.text}>
          <span>Total Billed Amount: </span>
          <span>{mission.bill_amount}</span>
          </div>
        </div>
      }
    </div>
    <div style={styles.rightSection}>
      <div style={styles.status(mission.status)}>
        { appConstants.MISSION[mission.status] }
      </div>
      <br/>
      {
        mission.payment_status && 
        <div style = {styles.payment(mission.payment_status)}>
          {appConstants.MISSION[mission.payment_status]}<br/>
          {`${mission.payment_status === 'billed' ? 'DUE: '+ mission.due_amount+' TK' : 'TOTAL: '+ mission.paid_amount+' TK'} `}
        </div>
      }
    </div>
  </div>
);

export default MissionBasicInfo;


// WEBPACK FOOTER //
// ./src/screens/mission-view/mission-basic-info.component.js